import { Dropzone } from '../components/FileUpload/Dropzone';
import { FileList } from '../components/FileList/FileList';
import { GlobalDropzone } from '../components/GlobalDropzone';
import { useGlobalDragAndDrop } from '../hooks/useGlobalDragAndDrop';

export const Files = () => {
  const {
    isDragOver,
    handleDragEnter,
    handleDragLeave,
    handleDrop,
    handleDragOver,
    isUploading,
  } = useGlobalDragAndDrop();

  return (
    <div
      className="relative p-6 py-4"
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
    >
      <div className="space-y-4">
        <Dropzone />
        <FileList />
      </div>

      <GlobalDropzone
        isVisible={isDragOver && !isUploading}
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
      />
    </div>
  );
};
